import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import moment from 'moment';
import { get, orderBy } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { css, cx } from '@bd/bdui-styles/emotion';
import { typography } from '../../styles';

const styles = css`
  @media (min-width: 768px) {
  }
  @media (min-width: 992px) {
  }
  @media (min-width: 1100px) {
  }
  .RecentPosts_header {
    font-family: ${typography.SerifHead};
    font-weight: bold;
    letter-spacing: 0.62px;
    font-style: italic;
    margin-bottom: 1.5em;
    color: white;
    @media (min-width: 768px) {
      font-size: 20px;
      margin-bottom: 1em;
    }
    @media (min-width: 992px) {
      font-size: 22px;
    }
  }
  .RecentPosts_postsWrapper {
    margin-bottom: -29px;
    @media (min-width: 576px) and (max-width: 991.98px) {
      column-count: 2;
    }
    @media (min-width: 576px) and (max-width: 767.98px) {
      column-gap: 40px;
    }
    @media (min-width: 768px) and (max-width: 991.98px) {
      column-gap: 60px;
    }
    @media (min-width: 992px) {
      margin-bottom: -31px;
    }
  }
  .RecentPosts_post {
    margin-bottom: 29px;
    @media (max-width: 575.98px) {
      &:nth-child(n+6) {
        display: none;
      }
    }
    @media (min-width: 576px) and (max-width: 991.98px) {
      display: inline-block;
      width: 100%;
      &:nth-child(7) {
        display: none;
      }
    }
    @media (min-width: 992px) {
      margin-bottom: 31px;
    }
  }
  .RecentPosts_postDate {
    font-size: 11.5px;
    font-weight: bold;
    letter-spacing: 0.125em;
    line-height: 1.375;
    text-transform: uppercase;
    color: #FFFFFF;
    margin-bottom: 0.5em;
    @media (min-width: 992px) {
      font-size: 12px;
    }
  }
  .RecentPosts_postTitle {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.375;
    margin: 0;
    text-transform: capitalize;
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .RecentPosts_postTitle a {
    @media (min-width: 992px) {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

function RecentPosts({ blogposts, className }) {
  return (
    <aside className={cx(styles, className)}>
      <h3 className="RecentPosts_header">Latest Posts</h3>
      <div className="RecentPosts_postsWrapper">
        {
          orderBy(blogposts, 'date', 'desc').slice(0, 7).map(post => {
            const postTitle = get(post, 'title');
            return (
              <div className="RecentPosts_post" key={post._id}>
                <div className="RecentPosts_postDate">{moment(get(post, 'date')).format('MMMM D, YYYY')}</div>
                <h5 className="RecentPosts_postTitle">
                  <Link name="blogpost-detail" params={{ blogpostTitle: postTitle }}>{postTitle}</Link>
                </h5>
              </div>
            );
          })
        }
      </div>
    </aside>
  );
}

RecentPosts.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
};

RecentPosts.defaultProps = {
  className: '',
};

export default withData({
  blogposts: true,
})(RecentPosts);



// WEBPACK FOOTER //
// ./src/pages/BlogpostDetail/RecentPosts.js